import IApplicationState from 'app/types/state';
import _ from 'lodash';

export function getCurrentBulkMatchPayment(state: IApplicationState) {
  if (
    state.bulkMatchPayments.bulkMatchPaymentsById !== undefined
    && state.bulkMatchPayments.currentBulkMatchPaymentId !== undefined
  ) {
    const f = state.bulkMatchPayments.bulkMatchPaymentsById[state.bulkMatchPayments.currentBulkMatchPaymentId];
    return f;
  }
  return {};
}

export function getCurrentFormBulkMatchPayment(state: IApplicationState) {
  return {
    ...getCurrentBulkMatchPayment(state),
    ...state.bulkMatchPayments.requestedData,
  };
}

export function getBulkMatchPayments(state: IApplicationState) {
  return {
    ...state.bulkMatchPayments,
    currentBulkMatchPayment: {
      ...getCurrentBulkMatchPayment(state),
    },
  };
}
